import HelpButton from "../../HelpButton";

export default function FinancesHelp() {
  return (
    <HelpButton>
      <div className="help-page">
        <p>
          Este módulo está diseñado para facilitar el seguimiento de los pagos
          de los miembros del grupo. Podés registrar cargos, como cuotas,
          campamentos y otros conceptos, así como los pagos realizados y los
          créditos obtenidos en campañas financieras.
        </p>
        <p>
          Si habilitas la opción en preferencias los miembros podrán consultar
          su estado de cuenta en cualquier momento desde el panel personal en{" "}
          <a
            className="link"
            href="https://sherpa.msu.edu.uy/personal/estado-cuenta"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://sherpa.msu.edu.uy/personal/estado-cuenta
          </a>
        </p>
        <p>
          En breve habilitaremos también la opción de enviar un recordatorio
          mensual por correo electrónico a cada miembro que tenga pagos
          pendientes.
        </p>
        <h4 className="text-lg font-bold">Cobro mensual de cuotas</h4>
        <p>
          El cobro de las cuotas mensuales se realiza automáticamente según el
          plan asignado a cada miembro.
        </p>
        <h4 className="text-lg font-bold">Suscipciones de MercadoPago</h4>
        <p>
          Para las suscripciones de MercadoPago, cada pago realizado se registra
          automáticamente en el estado de cuenta correspondiente.
        </p>
        <p>
          Necesitas configurarlo desde el panel de preferencias y en tu cuenta
          de Mercadopago. Puedes{" "}
          <a href="/sherpa-mercadopago.pdf" target="_blank" className="link">
            ver las instrucciones aqui
          </a>
        </p>
      </div>
    </HelpButton>
  );
}
